var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('carousel',{attrs:{"nav":false,"responsive":{
            0: {
                items: 1,
                dots: false,
                autoWidth: false,
                loop: false,
                center: false,
            },
            552: {
                items: 3,
                dots: false,
                autoWidth: false,
                loop: false,
                center: false,
            },
            768: {
                items: 5,
                dots: true,
                autoWidth: true,
                loop: true,
                center: true,
            }
        }}},_vm._l((_vm.people),function(person,index){return _c('div',{key:index,staticClass:"team-member"},[_c('b-avatar',{attrs:{"src":person.picture,"size":"8rem"}}),_c('a',{attrs:{"href":person.linkedinUrl,"target":"_blank","rel":"noreferrer"}},[_vm._v(" "+_vm._s(person.name)+" ")]),_c('h6',[_vm._v(_vm._s(person.title))])],1)}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }